import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  DASHBOARD_FETCH_DEFAULT_PASSWORD_BEGIN,
  DASHBOARD_FETCH_DEFAULT_PASSWORD_SUCCESS,
  DASHBOARD_FETCH_DEFAULT_PASSWORD_FAILURE,
  DASHBOARD_FETCH_DEFAULT_PASSWORD_DISMISS_ERROR,
  ERROR_CONTACT_ADMIN,
} from './constants';

export function fetchDefaultPassword() {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: DASHBOARD_FETCH_DEFAULT_PASSWORD_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.get(`${API_REQUEST_URL}/getDefaultPassword`, {
        headers: {
          Authorization: token,
        },
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: DASHBOARD_FETCH_DEFAULT_PASSWORD_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : ERROR_CONTACT_ADMIN;
          dispatch({
            type: DASHBOARD_FETCH_DEFAULT_PASSWORD_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchDefaultPasswordError() {
  return {
    type: DASHBOARD_FETCH_DEFAULT_PASSWORD_DISMISS_ERROR,
  };
}

export function useFetchDefaultPassword() {
  const dispatch = useDispatch();

  const { fetchDefaultPasswordPending, fetchDefaultPasswordError } = useSelector(
    state => ({
      fetchDefaultPasswordPending: state.dashboard.fetchDefaultPasswordPending,
      fetchDefaultPasswordError: state.dashboard.fetchDefaultPasswordError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchDefaultPassword(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchDefaultPasswordError());
  }, [dispatch]);

  return {
    fetchDefaultPassword: boundAction,
    fetchDefaultPasswordPending,
    fetchDefaultPasswordError,
    dismissFetchDefaultPasswordError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DASHBOARD_FETCH_DEFAULT_PASSWORD_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchDefaultPasswordPending: true,
        fetchDefaultPasswordError: null,
      };

    case DASHBOARD_FETCH_DEFAULT_PASSWORD_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchDefaultPasswordPending: false,
        fetchDefaultPasswordError: null,
      };

    case DASHBOARD_FETCH_DEFAULT_PASSWORD_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchDefaultPasswordPending: false,
        fetchDefaultPasswordError: action.data.error,
      };

    case DASHBOARD_FETCH_DEFAULT_PASSWORD_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchDefaultPasswordError: null,
      };

    default:
      return state;
  }
}
